module.exports = __webpack_public_path__ + "img/ennetix-xtend-table.7409dea3.png";